import { render, staticRenderFns } from "./all-corporations.vue?vue&type=template&id=25c59578&"
import script from "./all-corporations.vue?vue&type=script&lang=js&"
export * from "./all-corporations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports